import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

const isAccessAllowed = async (route: ActivatedRouteSnapshot, _: RouterStateSnapshot, authData: AuthGuardData) => {
  const { authenticated } = authData;
  return new Promise<boolean>((resolve) => {
    if (!authenticated) {
      const keycloak = inject(Keycloak);
      keycloak
        .login()
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          console.error(error);
          resolve(false);
        });
    } else {
      resolve(true);
    }
  });
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);
